export const setLS = (key, value) => {
    localStorage.setItem(key, value);
}

export const getLS = (key) => {
    return localStorage.getItem(key);
}

export const removeLS = (key) => {
    localStorage.removeItem(key);
}

export const clearLS = (key) => {
    localStorage.clear();
}
